import React from "react"
import Row from "@amzn/meridian/row"
import ModalExample from "@amzn/meridian/modal";
import Box from "@amzn/meridian/box";
import Text from "@amzn/meridian/text";
import Table, {TableRow, TableCell} from "@amzn/meridian/table";
import Column from "@amzn/meridian/column";
import Currency from "../../common/currency";
import Button from "@amzn/meridian/button";
import { oldTimeZoneMapper, handleBlankValue } from "../../common/commonUtils";

import {downloadPendingReconDetailsExcel} from "./pendingReconDetailsExcelDownload";



const OverviewSection = ({values}) => {

    return (<Box>
        <Column space="small">
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Driver Name</Text>
                {values.driverInfo.name}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Employee Id</Text>
                {values.compEmployeeId}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">DSP Name</Text>
                {values.providerInfo.name}
            </Row>
            <Row widths={["grid-4", "grid-8"]}>
                <Text type="h100">Pending Reconciliation</Text>
                <Currency amount={values.paymentInfo.overallPendingRecon} isVariance={true}/>
            </Row>

        </Column>
    </Box>);
}

const PendingReconDetailsSection = ({values}) => {

    return (
        <Table headerRows={1}>
            <TableRow>
                <TableCell>S.No.</TableCell>
                <TableCell>Time Stamp</TableCell>
                <TableCell>Tracking Id</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Payment Type</TableCell>
            </TableRow>

            {values.paymentInfo.overallPendingReconBreakdownList && values.paymentInfo.overallPendingReconBreakdownList.map(function (overallPendingReconBreakdown, index) {
                const {trackingId, paymentMethod, amount, moneyCollectionTime, stationTimeZone} = overallPendingReconBreakdown;

                let dateOption = {timeZone: stationTimeZone ? oldTimeZoneMapper(stationTimeZone) : undefined};
                let date = new Date(moneyCollectionTime).toLocaleString('en-US', dateOption);

                return <TableRow key={index}>
                    <TableCell>{index+1}</TableCell>
                    <TableCell>{handleBlankValue(date)}</TableCell>
                    <TableCell>{trackingId}</TableCell>
                    <TableCell><Currency amount={amount} isVariance={true}/></TableCell>
                    <TableCell>{paymentMethod}</TableCell>

                </TableRow>
            })}
        </Table>
    );
}

const PendingReconDetailsDownloadExcelSection = ({values}) => {
    console.log(values)
    return (
        <div>
            <div>
                <Button size="small" onClick={() => downloadPendingReconDetailsExcel(values)}
                        disabled={!values.paymentInfo.overallPendingReconBreakdownList
                        || (values.paymentInfo.overallPendingReconBreakdownList && values.paymentInfo.overallPendingReconBreakdownList.length === 0)}
                >
                    Download
                </Button>
            </div>
        </div>
    );
}


const PendingReconModal = (props) => {
    const { onClose, pendingReconModalData, value} = props;
    console.log(pendingReconModalData);
    console.log(value);

    return (
        <React.Fragment>
            <ModalExample title="Pending Reconciliation Details" open={props.value} scrollContainer="viewport"
                          closeLabel="Close" onClose={onClose}>

                {
                    <OverviewSection values={pendingReconModalData}/>
                }

                <br/>
                <br/>

                {
                    <PendingReconDetailsSection values={pendingReconModalData} />
                }

                <br/>
                <br/>
                <br/>


                {
                    <PendingReconDetailsDownloadExcelSection values={pendingReconModalData} />
                }


            </ModalExample>

        </React.Fragment>
    )
}

export default PendingReconModal


// WEBPACK FOOTER //
// ./src/component/modal/driverReconciliation/pendingReconModal.js